import { useEffect } from 'react';

export default function useOnKeydown(keyCodes = [], handler) {
	useEffect(() => {
		const handleKeydown = (event) => {
			if (keyCodes.includes(event.keyCode)) {
				handler();
			}
		};
		window.addEventListener('keydown', handleKeydown);

		return () => {
			window.removeEventListener('keydown', handleKeydown);
		};
	}, [handler, keyCodes]);
}
